export function registerPwaServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/pwa-service-worker.js', { scope: '/' })
      .catch((error) => {
        console.warn('[PWA] Service worker registration failed:', error?.message || error);
      });
  });
}
